"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timer = void 0;
class Timer {
    constructor(options, timerCallback) {
        this.time = 0;
        this.timerCallback = () => { };
        this.id = null;
        this.options = {
            callbackFunction: () => { },
            duration: 3000,
            args: [],
        };
        this.setOptions(options);
        this.setTimerCallback(timerCallback);
    }
    timerHandler() {
        this.time += Timer.INTERVAL_DURATION;
        this.timerCallback({
            timerCount: this.time,
        });
        const remainedTime = this.options.duration - this.time;
        if (remainedTime <= 0) {
            this.remove();
            this.options.callbackFunction(...this.options.args);
        }
    }
    setTimerCallback(callback) {
        if (callback) {
            this.timerCallback = callback;
        }
    }
    setOptions(options) {
        this.options = Object.assign(Object.assign({}, this.options), options);
        this.options.duration = this.transformDuration(this.options.duration);
        this.remove();
    }
    init() {
        this.remove();
        this.id = setInterval(this.timerHandler.bind(this), Timer.INTERVAL_DURATION);
    }
    reInit() {
        this.init();
    }
    remove() {
        this.time = 0;
        if (this.id) {
            clearInterval(this.id);
        }
    }
    getRemainedTime() {
        return this.options.duration - this.time;
    }
    transformDuration(duration) {
        return duration / Timer.INTERVAL_DURATION * 100;
    }
}
exports.Timer = Timer;
Timer.INTERVAL_DURATION = 100;
//# sourceMappingURL=Timer.js.map